// extracted by mini-css-extract-plugin
export default {"wrapper":"I-t8ICpLZyz5FysnHHWu7Q==","textBox":"xf4TZ4WeTjiIswl7E18w4Q=="};